<template>
  <div class="appointmentDemo_modal" v-if="isShow">
    <div class="appointmentDemo_modal_wrapper">
      <div>
        <img src="/static/imgs/consult_close.svg" alt="" class="appointmentDemo_modal_close" @click="close">
      </div>
      <div class="appointmentDemo_modal_content"  v-if="submit">
        <div class="appointmentDemo_modal_content_title">
          You have made an appointment successfully
          <div class="title_icon"></div>
        </div>
        <p class="appointmentDemo_modal_content_msg">
          An account manager will contact you within <span :style="{color: '#FC5421'}">1 working day</span>  to schedule a specific demo.
        </p>
        <div class="appointmentDemo_modal_content_submit">
          <img :src="`static/imgs/appointmentDemo5.svg`" alt="" />
        </div>
        <div class="appointmentDemo_modal_content_form_btn_submit" @click="backHome">Back to Home</div>
      </div>
      <div class="appointmentDemo_modal_content" v-else>
        <div class="appointmentDemo_modal_content_title">
          Book a Free Demo
          <div class="title_icon"></div>
        </div>
        <p class="appointmentDemo_modal_content_msg">
          Please leave your contact information, our account manager will
          contact you within one working day and make an appointment for a
          specific demonstration.
        </p>
        <div class="appointmentDemo_modal_content_introduction">
          <div
            class="appointmentDemo_modal_content_introduction_part"
            v-for="(item, index) in introductionList"
            :key="item"
          >
            <img :src="`static/imgs/appointmentDemo${index + 1}.svg`" alt="" />
            <p>{{ item }}</p>
          </div>
        </div>
        <div class="appointmentDemo_modal_content_form">
          <div>
            <input type="text"  placeholder="Email" v-model="form.email" />
            <span class="appointmentDemo_modal_content_form_tip" v-if="error">*Please check your email</span>
          </div>
          <div class="appointmentDemo_modal_content_form_code">
            <input type="text"  placeholder="Verification Code" v-model="form.code" />
            <div @click="getCode" v-if="showCode">Get Code</div>
            <div class="appointmentDemo_disabled" v-else>Get Code({{waittime}})</div>
          </div>
          <span class="appointmentDemo_modal_content_form_tip" v-if="error2">*Please check your verification code</span>
          <div>
            <input type="text"  placeholder="Name" v-model="form.name"/>
          </div>
          <div>
            <input type="text"  placeholder="Company Name" v-model="form.company" />
          </div>
          <div>
            <select v-model="form.language">
              <option value="en">Language-English</option>
              <option value="zh">Language-Chinese</option>
            </select>
          </div>
        </div>
        <div class="appointmentDemo_modal_content_form_btn" v-if="checkValue()" @click="submitInfo">Comfirm</div>
        <div class="appointmentDemo_modal_content_form_btn appointmentDemo_disabled" v-else>Comfirm</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isShow"],
  data() {
    return {
      introductionList: [
        "One-to-one detailed answer",
        "Learn more about system features",
        "Demonstration of the whole process of system practical operation",
        "Provide professional solutions",
      ],
      form:{
        email:'',
        code:'',
        name:'',
        company:'',
        language:'en',
      },
      error:false,
      error2:false,
      showCode:true,
      waittime:59,
      submit:false,
      code:''
    };
  },
  methods: {
    getCode(){
      let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if(!reg.test(this.form.email)){
        this.error = true
        return
      }
      this.code = Math.floor( Math.random() * 900000 + 100000)
      this.error = false
      this.showCode = false
      this.count()
      let params = {
        book_demo:{
          email: this.form.email,
          code:this.code
        }
      }
      this.$axios.post('https://gateway.antdiy.vip/account-service/email/send',params).then(res=>{

      })

    },
    checkValue(){
      let form = this.form
      let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if(form.code.trim() && form.email.trim() && reg.test(form.email)){
        return true
      }
      return false
    },
    count() {
      let siv = setInterval(() => {
        this.waittime--;
        if (this.waittime <= -1) {
          clearInterval(siv);
          this.waittime = 59;
          this.showCode = true;
        }
      }, 1000);
    },
    close(){
      this.$emit('close')
      this.form = {
        email:'',
        code:'',
        name:'',
        company:'',
      }
      this.submit = false
      if(!this.showcode){

      }
    },
    backHome(){
      this.close()
      this.$router.push({path: '/home'})
    },
    submitInfo(){
      let form = this.form
      if(form.code.trim() != this.code){
        this.error2 = true
        return
      }
      this.error2 = false
      let params = {
        book_demo_reply:{
          email: this.form.email
        }
      }
      this.$axios.post('https://gateway.antdiy.vip/account-service/email/send',params).then(res=>{

      })
      this.$axios.get(`https://gateway.antdiy.vip/website/chat/0b5c1899805ec43213876bc1ce2a703b5f2758a1f7052c316fd8a00459e420aa`,{
        params:{
          message: `客户需要预约演示(ANTDIY PRO)，请售前尽快联系安排！\n客户邮箱：${this.form.email}\n客户姓名：${this.form.name}\n公司名称：${this.form.company}\n客户语言:${this.form.language==='en' ? '英语': '中文'}`
        }
      })
      this.submit = true
    }
  }
};
</script>

<style>
.appointmentDemo_modal {
  background: #0000007f;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.appointmentDemo_modal_wrapper {
  max-height: 100%;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(221, 221, 221, 0.43);
  border-radius: 20px;
  width: 568px;
  padding: 37px 50px 50px;
  position: relative;
}
.appointmentDemo_modal_content {
}
.appointmentDemo_modal_content_title {
  text-align: center;
  font-family: Helvetica-Bold;
  font-size: 36px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
}
.appointmentDemo_modal_content_title > div {
  width: 60px;
  height: 8px;
  border-radius: 6px;
  margin: 20px auto 0;
}
.appointmentDemo_modal_content_msg {
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0.25px;
  text-align: center;
  line-height: 26px;
  font-weight: 400;
  margin-top: 33px;
}
.appointmentDemo_modal_content_introduction {
  margin-top: 30px;
  padding: 20px 14px;
  background: #fdf5f2;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.appointmentDemo_modal_content_introduction_part {
  width: 48%;
  display: flex;
  align-items: baseline;
}
.appointmentDemo_modal_content_introduction_part:nth-of-type(1) {
  margin-bottom: 28px;
}
.appointmentDemo_modal_content_introduction_part:nth-of-type(2) {
  margin-bottom: 28px;
}
.appointmentDemo_modal_content_introduction_part > img {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}
.appointmentDemo_modal_content_introduction_part > p {
  font-family: Helvetica;
  font-size: 14px;
  color: #222536;
  letter-spacing: 0.19px;
  line-height: 16px;
  font-weight: 400;
}
.appointmentDemo_modal_content_form {
  margin-top: 5px;
}
.appointmentDemo_modal_content_form input, .appointmentDemo_modal_content_form select {
  margin-top: 25px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  border-radius: 8px;
  width: 100%;
  height: 50px;
  font-family: Helvetica;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.68);
  font-weight: 400;
  padding-left: 16px;
}
.appointmentDemo_modal_content_form select {
  outline: none;
  appearance: none;
  /*在选择框的最右侧中间显示小箭头图片*/
  background: url(../../assets/pull_down.svg) no-repeat scroll 96% center transparent;
}
.appointmentDemo_modal_content_form select::-ms-expand {
  display: none;
}

.appointmentDemo_modal_content_form_tip{
  margin-top: 3px;
  display: inline-block;
  color: #fc5322;
}
.appointmentDemo_modal_content_form_code {
  display: flex;
  align-items: flex-end;
}
.appointmentDemo_modal_content_form_code div {
  background: #fc5322;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  border-radius: 4px;
  width: 170px;
  height: 50px;
  margin-left: 20px;
  font-family: Helvetica;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.appointmentDemo_modal_content_form_btn {
  background: #fc5322;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  border-radius: 4px;
  font-family: Helvetica;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
  margin-top: 40px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.appointmentDemo_disabled{
  opacity: 0.2;
  cursor: not-allowed !important;
  filter:grayscale(100%);
}
.appointmentDemo_modal_close{
  position: absolute;
  right: 50px;
  top: 15px;
  cursor: pointer;
  height: 40px;
}
.appointmentDemo_modal_content_submit{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 28px;
  height: 285px;
}
.appointmentDemo_modal_content_form_btn_submit{
  background: #fc5322;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  border-radius: 4px;
  font-family: Helvetica;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .appointmentDemo_modal_wrapper {
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 0px 2px 15px 0px rgba(221, 221, 221, 0.43);
    border-radius: 10px;
    width: 100%;
    padding: 1rem .48rem .5rem;
    position: relative;
  }
  .appointmentDemo_modal_content_title {
    text-align: center;
    font-family: Helvetica-Bold;
    font-size: .4rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    font-weight: 700;
  }
  .appointmentDemo_modal_content_msg {
  font-family: PingFangSC-Regular;
  font-size: .24rem;
  color: #222536;
  letter-spacing: 0.33px;
  text-align: center;
  line-height: .32rem;
  font-weight: 400;
  margin-top: .4rem;
}
.appointmentDemo_modal_content_introduction {
  margin-top: .4rem;
  padding: .2rem .14rem;
  background: #fdf5f2;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.appointmentDemo_modal_content_introduction_part {
  width: 48%;
  display: flex;
}
.appointmentDemo_modal_content_introduction_part:nth-of-type(1) {
  margin-bottom: .14rem;
}
.appointmentDemo_modal_content_introduction_part:nth-of-type(2) {
  margin-bottom: .14rem;
}
.appointmentDemo_modal_content_introduction_part > img {
  width: .14rem;
  height: .14rem;
  margin-right: 8px;
}
.appointmentDemo_modal_content_introduction_part > p {
  font-family: Helvetica;
  font-size: .16rem;
  color: #222536;
  letter-spacing: 0.19px;
  line-height: .2rem;
  font-weight: 400;
}
.appointmentDemo_modal_content_form {
  margin-top: .08rem;
}
.appointmentDemo_modal_content_form input, .appointmentDemo_modal_content_form select {
  margin-top: .26rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  border-radius: 8px;
  width: 100%;
  height: .56rem;
  font-family: Helvetica;
  font-size: .18rem;
  color: rgba(0, 0, 0, 0.68);
  font-weight: 400;
  padding-left: .18rem;
}
.appointmentDemo_modal_content_form_tip{
  margin-top: .03rem;
  display: inline-block;
  color: #fc5322;
}
.appointmentDemo_modal_content_form_code {
  display: flex;
  align-items: flex-end;
}
.appointmentDemo_modal_content_form_code div {
  background: #fc5322;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  border-radius: 4px;
  width: 1.7rem;
  height: .56rem;
  margin-left: .2rem;
  font-family: Helvetica;
  font-size: .18rem;
  color: #ffffff;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.appointmentDemo_modal_content_form_btn {
  background: #fc5322;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  border-radius: 4px;
  font-family: Helvetica;
  font-size: .18rem;
  color: #ffffff;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
  margin-top: .4rem;
  height: .6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.appointmentDemo_disabled{
  opacity: 0.2;
  cursor: not-allowed !important;
}
.appointmentDemo_modal_close{
  position: absolute;
  right: .35rem;
  top: .3rem;
  cursor: pointer;
  height: .55rem;
}
.appointmentDemo_modal_content_submit{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: .28rem;
  height: 2.75rem;
}
.appointmentDemo_modal_content_submit img {
  width: 100%;
  height: 100%;
}
.appointmentDemo_modal_content_form_btn_submit{
    background: #fc5322;
    box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
    border-radius: 4px;
    font-family: Helvetica;
    font-size: .18rem;
    color: #ffffff;
    letter-spacing: 0.5px;
    text-align: center;
    font-weight: 400;
    cursor: pointer;
    height: .55rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/appointmentDemo.vue